import { ArticleDto } from "./article.dto";
import { AssessDetailDto } from "./assess-detail.dto";
import { ProductionOrderProcessDto } from "./production-order-process.dto";

export class AssessDto {
    id?: number;
    description!: string;
    articleId!: number;
    productionProcessId!: number;
    quantity!: number;
    assessDetails?: AssessDetailDto[];
    articlesAlternatives?: ArticleDto[];
}
